import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { EncryptionProviderService } from '@shared/services/encryption.service';
import { environment } from "./../../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private readonly http: HttpClient,
    private encryptionProviderService: EncryptionProviderService) { }

  public getData(endPoint):  Observable<any> {
    return Observable.create((observer) => {
      this.http
      .get<any>(endPoint)
      .pipe(timeout(60000))
      .subscribe(
        (response) => {
          if (response['eData']) {
            response = JSON.parse(
              this.encryptionProviderService.decryptData(response['eData'])
            );
          }
          if (response.status === 0) {
            observer.next(response);
          } else {
            observer.error(response);
          }
        },
        (error) => {
          observer.error(error);
        },
        () => observer.complete()
      );
    }); 
  }

  public postData(endPoint,data):Observable<any>{
    return Observable.create((observer) => {
      if (environment.isEncryptionEnabled) {
        data = !data ? {} : data;
        data.guid = this.generateGuid(endPoint);
        data.timeStamp = Date.now();
        data = {
          eData: this.encryptionProviderService.encryptData(
            JSON.stringify(data)
          ),
        };
      }
      this.http
        .post<any>(endPoint, data)
        .pipe(timeout(60000))
        .subscribe(
          (response) => {
            if (response['eData']) {
              response =  JSON.parse(this.encryptionProviderService.decryptData(
                response['eData']
              ));
            }
            if (response.status === 0) {
              observer.next(response);
            } else {
              observer.error(response);
            }
          },
          (error) => {
            observer.error(error);
          },
          () => observer.complete()
        );
    });
  }

  generateGuid(url: string) {
    let result = '';
    const length = 32;
    const chars =
      '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (let i = length; i > 0; --i) {
      result += chars[Math.round(Math.random() * (chars.length - 1))];
    }

    this.encryptionProviderService.setGuid({
      key: url,
      value: result,
    });

    return result;
  }
}
